/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_invite_page_toast_already_accepted_continue = /** @type {(inputs: {}) => string} */ () => {
	return `Ya has aceptado esta invitación. Puedes continuar en la aplicación.`
};

const en_invite_page_toast_already_accepted_continue = /** @type {(inputs: {}) => string} */ () => {
	return `You've already accepted this invitation. You can continue in the application.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const invite_page_toast_already_accepted_continue = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.invite_page_toast_already_accepted_continue(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("invite_page_toast_already_accepted_continue", locale)
	if (locale === "es") return es_invite_page_toast_already_accepted_continue(inputs)
	return en_invite_page_toast_already_accepted_continue(inputs)
};
export { invite_page_toast_already_accepted_continue as "invite.page.toast_already_accepted_continue" }